import { useTranslation } from 'react-i18next';

const NoConfigPlaceholder = () => {
    const { t } = useTranslation('integrations');

    return (
        <div className="flex-1 min-h-[300px] flex items-center justify-center text-content-weak">
            <div className="text-center p-8">
                <div className="text-lg mb-2">{t('outputMapper.form.noConfigAvailable')}</div>
                <div className="text-sm">{t('outputMapper.form.noConfigAvailableDescription')}</div>
            </div>
        </div>
    );
};

export default NoConfigPlaceholder;
